import React, { useEffect, useRef } from 'react';
import { Typography, Card, Grid, Button, Autocomplete, Stack } from "@mui/material";
import CssTextField from '../../../../components/overrides/longSearchField'
// import BlackButton from '../../../../components/overrides/blackButton'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { cnsListWatcher } from '../../../../redux/actionCreators/admin/contractorBook';
import { createContractorOrderWatcher, cancelContractOrderWatcher } from '../../../../redux/actionCreators/contractor';
import { updateAlert } from '../../../../redux/actionCreators/alert';
import CancelDialog from '../../../../components/admin/kitchen/contractorBook/cancelDialog';
import { timeVal, vendorCafeteriaId } from '../../../../utils/common';
import { OVERALL_CAFETERIA_ID } from '../../../../utils/constants';
import { getDropDownWatcher } from '../../../../redux/actionCreators/admin/employeeManagement';
import { getRosterWatcher } from '../../../../redux/actionCreators/admin/rosterManagement';
import { getConvertedDate } from '../../../../utils/common';
import { selectGuestCountWatcher } from '../../../../redux/actionCreators/admin/guestBook';

const MealBooking = () => {

    const dispatch = useDispatch();
    const { ContractorBookReducers: { menuIdList }, RosterReducers: { rosterList }, EmployeeReducers: { vendorName, cafeteriaName }, GuestBookReducers: { guestUserCount }, } = useSelector((state) => state)

    const { ProfileReducers: { loginState } } = useSelector(state => state)
    const nUserName = loginState[0]?.cUserName || ''
    const nContractorName = loginState[0]?.cEmployeeName || ''
    const nContractorId = loginState[0]?.nID || ''
    const nUserID = loginState[0]?.nID
    const nCRoleID = loginState[0]?.nContractorID
    const tempinitsform = useRef();
    const tempinits = useRef();
    const tempinit = useRef();
    const temp = useRef();

    const gCount = guestUserCount[0]?.GuserCount ? guestUserCount[0]?.GuserCount : 0

    var today = new Date();
    var bookingTime = timeVal(today)

    // Every active vendor, as on the admin's Contractor Book; the meal fields show
    // the chosen vendor's own items. The fields are keyed by the cafeteria the
    // booking is stored against: the one the vendor serves on the order date
    // (tomorrow), else the active cafeteria.
    const orderDay = new Date(today)
    orderDay.setDate(orderDay.getDate() + 1)
    const defaultCafeId = (cafeteriaName || []).map(c => +c.id).filter(id => id !== OVERALL_CAFETERIA_ID).sort((a, b) => a - b)[0]
    const vendorOptions = (vendorName || [])
        .filter(v => +v.id !== OVERALL_CAFETERIA_ID)
        .map(v => ({ id: +v.id, name: v.name, cafeteriaId: vendorCafeteriaId(rosterList, v.id, orderDay) ?? defaultCafeId }))
        .filter(v => v.cafeteriaId)
    const MEALS = ['Breakfast', 'Lunch', 'Snacks', 'Dinner', 'Supper', 'Snacks(Take away)']

    const custValidation = (Yup, cafeteriaList) => {
        if (cafeteriaList.length) {
            const cust = {}
            const meals = MEALS
            cafeteriaList.forEach(m => {
                const diff = cafeteriaList.filter(f => f.id !== m.id)

                meals.forEach(d => {
                    const getBal = (values) => {
                        const bal = diff.reduce((a, b) => {
                            return a + (values[`${d}-${b.id}`] || 0)
                        }, 0)
                        return bal
                    }

                    cust[`${d}-${m.id}`] = Yup.number().test("Invalid count", "Invalid count", (data = 0, mm) => {
                        if ((data + getBal(mm.parent)) > gCount) {
                            return false
                        }
                        return true
                    })
                })

            })
            return cust
        }
        return {}
    }

    const Schema = (cafeteriaList) => Yup.object().shape({
        // contractorID: Yup.string().min(1, 'Too Short!').max(500, 'Too Long!').required('Please select contractor'),
        vendorID: Yup.string().required('Please select vendor'),
        ...custValidation(Yup, cafeteriaList)
    });

    const formik = useFormik({
        initialValues: {
            userName: '',
            contractorID: '',
            contractorName: '',
            vendorID: '',
            orderDate: '',
            supperDate: ''
        },
        validationSchema: () => Schema(cafeteriaList),

        onSubmit: () => {
            const { userName, contractorID, vendorID, orderDate, contractorName, supperDate, ...rest } = { ...formik.values }
            let mealArr = []

            Object.keys(rest).forEach((key, index) => {
                const mealObj = pickRow(key)
                // only meals the chosen vendor actually has
                if (!mealObj.nMenuID) return
                if (rest[key] !== 0 && rest[key] !== '' && +rest[key] !== +mealObj.nQuantity) {
                    mealArr.push({ ...mealObj, nQuantity: +rest[key] })
                }
            })

            const data = {
                "ACTION": "InsertOrderBooking",
                "nContractorID": `${contractorID}`,
                "bookingData": mealArr,
                nUserID,
                nBookingID: getBookingId(),
                nVendorID: vendorID
            }

            if (mealArr.length) {
                dispatch(createContractorOrderWatcher(data))
            }
        }
    });
    const { errors, touched, handleSubmit, getFieldProps, setFieldValue, values } = formik;

    const selectedVendor = vendorOptions.find(v => +v.id === +values.vendorID) || null
    const cafeteriaList = selectedVendor ? [{ id: selectedVendor.cafeteriaId, name: selectedVendor.name }] : []

    // A meal the chosen vendor has no item for can't be booked
    const noItem = (key) => !menuIdList.some(m => m.cmealName === key && m.nMenuID)

    // A vendor can have more than one item for a meal, and the list arrives in
    // no fixed order. Show and save the same item every time: the one already
    // booked, else the lowest menu id.
    const pickRow = (key) => {
        const rows = menuIdList.filter(m => m.cmealName === key)
        return rows.find(r => r.BookingdeatilsID)
            || [...rows].sort((a, b) => a.nMenuID - b.nMenuID)[0]
            || {}
    }

    const initsform = () => {
        // Another vendor's quantities must not carry over
        vendorOptions.forEach(v => MEALS.forEach(meal => setFieldValue(`${meal}-${v.cafeteriaId}`, '')))

        if (values.contractorID !== '' && values.vendorID !== '') {
            let data = {
                "ACTION": "Cns",
                "nID": `${values.contractorID}`,
                "nVendorID": values.vendorID
            }
            let dat = {
                "ACTION": "CuserCount",
                "nID": `${nCRoleID}`
            }
            dispatch(cnsListWatcher(data, true))
            dispatch(selectGuestCountWatcher(dat))
        }
    };

    tempinitsform.current = initsform;

    useEffect(() => {
        tempinitsform.current();
    }, [values.contractorID, values.vendorID]);

    // The vendor serving tomorrow is picked for the user
    const rosteredVendorId = (vendorOptions.find(v => vendorCafeteriaId(rosterList, v.id, orderDay) !== null) || {}).id
    useEffect(() => {
        if (!values.vendorID && rosteredVendorId) setFieldValue('vendorID', rosteredVendorId)
    }, [rosteredVendorId, values.vendorID, setFieldValue]);


    // useEffect(() => {
    //     if (values.contractorID !== '') {
    //         let data = {
    //             "ACTION": "Cns",
    //             "nID": `${values.contractorID}`
    //         }
    //         dispatch(cnsListWatcher(data, true))
    //     }
    // }, [values.contractorID])

    const getBookingId = () => {
        const get = menuIdList.find(d => d.nid) || {}
        return get.nid
    }

    const inits = () => {
        if (menuIdList.length) {
            [...new Set(menuIdList.map(m => m.cmealName))].forEach(key => setFieldValue(key, pickRow(key).nQuantity))
        }
    };

    tempinits.current = inits;

    useEffect(() => {
        tempinits.current();
    }, [menuIdList]);


    // useEffect(() => {
    //     if (menuIdList.length) {
    //         menuIdList.map(m => (setFieldValue(m.cmealName, m.nQuantity)))
    //     }
    // }, [menuIdList])

    const init = () => {
        dispatch(getRosterWatcher({ ACTION: "SELECT" }));
        dispatch(getDropDownWatcher());
    };

    tempinit.current = init;

    useEffect(() => {
        tempinit.current();
    }, []);


    // useEffect(() => {
    //     if (!cafeteriaName.length) {
    //         dispatch(getDropDownWatcher());
    //     }
    // }, [cafeteriaName])

    const tempform = () => {
        setFieldValue("contractorID", nContractorId)
        setFieldValue("contractorName", nContractorName)
        setFieldValue("userName", nUserName)
        const today = new Date();
        let tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        setFieldValue("orderDate", tomorrow)
        setFieldValue("supperDate", getConvertedDate(tomorrow))
    };

    temp.current = tempform;

    useEffect(() => {
        temp.current();
    }, []);


    // useEffect(() => {
    //     setFieldValue("contractorID", nContractorId)
    //     setFieldValue("contractorName", nContractorName)
    //     setFieldValue("userName", nUserName)
    //     const today = new Date();
    //     let tomorrow = new Date(today);
    //     tomorrow.setDate(tomorrow.getDate() + 1);
    //     setFieldValue("orderDate", tomorrow)
    // }, [])

    const handleCancel = () => {

        if (!getBookingId()) {
            return dispatch(updateAlert('There is no order to cancel', 'error'))
        }

        if (values.contractorID !== '') {
            let id = getBookingId()
            let data = {
                ACTION: "OrderCancel",
                nContractorId: values.contractorID,
                nVendorID: values.vendorID
            }
            dispatch(cancelContractOrderWatcher(id, data))
        }
    }

    return (
        <>
            <Card style={{ boxShadow: (theme) => `0px 12px 23px ${theme.palette.grey[200]}` }}>
                <Grid container spacing={3} sx={{ padding: '30px' }} >
                    <Grid item lg={6} xs={6} sx={{ justifyContent: 'left' }}>
                        <div>
                            <Typography variant='t20_600'> Meal Booking </Typography>
                        </div>
                    </Grid>
                </Grid>

                <Grid container spacing={3} display='flex' flexDirection='row' justifyContent='left' sx={{ padding: '30px', pb: '60px' }}>
                    <Grid item
                        lg={4}
                        xs={4}
                        md={4}
                        sm={4}
                    >
                        <Typography variant='t14_600'> User Name </Typography>
                        <CssTextField sx={{
                            '& .MuiOutlinedInput-root': {
                                height: '42px'
                            }
                        }}
                            placeholder='User Name'
                            name='contractorName'
                            fullWidth
                            InputProps={{ readOnly: true }}
                            size='medium'
                            {...getFieldProps("contractorName")}
                            error={Boolean(touched.contractorName && errors.contractorName)}
                            helperText={touched.contractorName && errors.contractorName}
                        />
                    </Grid>

                    <Grid item
                        lg={4}
                        xs={4}
                        md={4}
                        sm={4}
                    >
                        <Typography variant='t14_600'> User ID </Typography>
                        <CssTextField sx={{
                            '& .MuiOutlinedInput-root': {
                                height: '42px'
                            }
                        }}
                            placeholder='User ID'
                            name='userName'
                            fullWidth
                            InputProps={{ readOnly: true }}
                            size='medium'
                            {...getFieldProps("userName")}
                            error={Boolean(touched.userName && errors.userName)}
                            helperText={touched.userName && errors.userName}
                        />
                    </Grid>

                    <Grid item
                        lg={4}
                        xs={4}
                        md={4}
                        sm={4}
                    >
                        <Typography variant='t14_600'> Order Date </Typography>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                // label='Order Date'
                                name="orderDate"
                                onChange={() => {
                                    // setFieldValue("orderDate", newValue)
                                }}
                                // {...getFieldProps("orderDate")}
                                value={values.orderDate}
                                renderInput={(params) => <CssTextField {...params} fullWidth sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: '42px'
                                    }
                                }} />}
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item
                        lg={4}
                        xs={4}
                        md={4}
                        sm={4}
                    >
                        <Typography variant='t14_600'> Vendor </Typography>
                        <Autocomplete
                            disablePortal
                            id="vendor-select"
                            fullWidth
                            disableClearable
                            options={vendorOptions}
                            value={selectedVendor}
                            autoHighlight
                            noOptionsText='No vendor is serving on the order date'
                            getOptionLabel={(option) => option.name || ''}
                            isOptionEqualToValue={(option, value) => +option.id === +value.id}
                            onChange={(event, value) => {
                                setFieldValue("vendorID", value?.id || '');
                            }}
                            renderInput={(params) => <CssTextField {...params}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: '42px',
                                        padding: '0 9px'
                                    }
                                }}
                                name="vendorID"
                                placeholder="Select Vendor"
                                error={Boolean(touched.vendorID && errors.vendorID)}
                                helperText={touched.vendorID && errors.vendorID}
                            />}
                        />
                    </Grid>
                </Grid>
                {cafeteriaList?.map((m, i) => (
                    <Grid key={m.id} container spacing={3} display='flex' flexDirection='row' justifyContent='left' sx={{ padding: '30px', pt: 0 }}>

                        <Grid item
                            lg={1.8}
                            xs={4}
                            md={3}
                        >
                            <Typography variant='t14_600'> Breakfast </Typography>
                            <CssTextField sx={{
                                '& .MuiOutlinedInput-root': {
                                    height: '42px'
                                }
                            }}
                                placeholder='Breakfast'
                                name={`Breakfast-${m.id}`}
                                fullWidth
                                size='medium'
                                {...getFieldProps(`Breakfast-${m.id}`)}
                                value={values[`Breakfast-${m.id}`] || ''}
                                disabled={noItem(`Breakfast-${m.id}`)}
                                error={Boolean(touched[`Breakfast-${m.id}`] && errors[`Breakfast-${m.id}`])}
                            />
                        </Grid>

                        <Grid item
                            lg={1.8}
                            xs={4}
                            md={3}
                        >
                            <Typography variant='t14_600'> Lunch </Typography>
                            <CssTextField sx={{
                                '& .MuiOutlinedInput-root': {
                                    height: '42px'
                                }
                            }}
                                placeholder='Lunch'
                                name={`Lunch-${m.id}`}
                                fullWidth
                                size='medium'
                                {...getFieldProps(`Lunch-${m.id}`)}
                                value={values[`Lunch-${m.id}`] || ''}
                                disabled={noItem(`Lunch-${m.id}`)}
                                error={Boolean(touched[`Lunch-${m.id}`] && errors[`Lunch-${m.id}`])}
                            />
                        </Grid>

                        <Grid item
                            lg={1.8}
                            xs={4}
                            md={3}
                        >
                            <Typography variant='t14_600'> Snacks </Typography>
                            <CssTextField sx={{
                                '& .MuiOutlinedInput-root': {
                                    height: '42px'
                                }
                            }}
                                placeholder='Snacks'
                                name={`Snacks-${m.id}`}
                                fullWidth
                                size='medium'
                                {...getFieldProps(`Snacks-${m.id}`)}
                                value={values[`Snacks-${m.id}`] || ''}
                                disabled={noItem(`Snacks-${m.id}`)}
                                error={Boolean(touched[`Snacks-${m.id}`] && errors[`Snacks-${m.id}`])}
                            />
                        </Grid>

                        <Grid item
                            lg={1.8}
                            xs={4}
                            md={3}
                        >
                            <Typography variant='t14_600'> Dinner </Typography>
                            <CssTextField sx={{
                                '& .MuiOutlinedInput-root': {
                                    height: '42px'
                                }
                            }}
                                placeholder='Dinner'
                                name={`Dinner-${m.id}`}
                                fullWidth
                                size='medium'
                                {...getFieldProps(`Dinner-${m.id}`)}
                                value={values[`Dinner-${m.id}`] || ''}
                                disabled={noItem(`Dinner-${m.id}`)}
                                error={Boolean(touched[`Dinner-${m.id}`] && errors[`Dinner-${m.id}`])}
                            />
                        </Grid>

                        <Grid item
                            lg={1.8}
                            xs={4}
                            md={3}
                        >
                            <Typography variant='t14_600'> Supper </Typography>
                            <CssTextField sx={{
                                '& .MuiOutlinedInput-root': {
                                    height: '42px'
                                }
                            }}
                                placeholder='Supper'
                                name={`Supper-${m.id}`}
                                fullWidth
                                size='medium'
                                {...getFieldProps(`Supper-${m.id}`)}
                                value={values[`Supper-${m.id}`] || ''}
                                disabled={noItem(`Supper-${m.id}`)}
                                error={Boolean(touched[`Supper-${m.id}`] && errors[`Supper-${m.id}`])}
                            />
                        </Grid>

                        <Grid item
                            lg={1.85}
                            xs={6}
                            md={3}
                        >
                            <Typography variant='t14_600'> {'Snacks(Take away)'} </Typography>
                            <CssTextField sx={{
                                '& .MuiOutlinedInput-root': {
                                    height: '42px'
                                }
                            }}
                                placeholder='Snacks(Take away)'
                                name={`Snacks(Take away)-${m.id}`}
                                fullWidth
                                size='medium'
                                {...getFieldProps(`Snacks(Take away)-${m.id}`)}
                                value={values[`Snacks(Take away)-${m.id}`] || ''}
                                disabled={noItem(`Snacks(Take away)-${m.id}`)}
                                error={Boolean(touched[`Snacks(Take away)-${m.id}`] && errors[`Snacks(Take away)-${m.id}`])}
                            />
                        </Grid>
                    </Grid>
                ))}

                <Stack color='common.sred' spacing={0.5} mt='20px' ml='30px' >
                    <Typography variant='t14_600'>Note:</Typography>
                    {bookingTime ?
                        <>
                            <Typography variant='t14_400'>{`Please note the supper booking is applicable for ${values.supperDate}`}</Typography>

                            <Typography variant='t14_400'>{`Maximum no of allowed quantity for booking in each session is ${values.contractorID ? gCount : 0}.`}</Typography>
                        </>
                        :
                        <Typography variant='t14_400'>{`Please note the order booking is not available after 7PM `}</Typography>
                    }
                </Stack>

                <Grid container
                    display='flex'
                    flexDirection='row'
                    justifyContent='flex-end'
                    spacing={2}
                    sx={{ padding: '50px' }}
                >
                    <Grid item >
                        <CancelDialog handleCancel={handleCancel} />
                    </Grid>
                    <Grid item >
                        <Button sx={{
                            width: '120px',
                            height: '42px',
                            left: '0px',
                            top: '0px',
                            backgroundColor: 'common.Bblack',
                            '&: hover': {
                                backgroundColor: 'common.Bblack',
                            }
                        }} variant='contained' color='primary' onClick={handleSubmit}
                            type='submit'
                            disabled={bookingTime ? false : true}
                        >
                            <Typography variant='t16_400' color='inherit'>Save</Typography>
                        </Button>
                    </Grid>
                </Grid>
            </Card>
        </>

    )
}

export default MealBooking;